import {Locale} from '@aboutyou/config';

const showLoginAsDefaultCountries = [
  Locale.cs_CZ,
  Locale.de_DE,
  Locale.en_DE,
  Locale.de_CH,
  Locale.fr_CH,
  Locale.de_AT,
  Locale.fr_BE,
  Locale.nl_BE,
  Locale.nl_NL,
];

export const getShowLoginAsDefault = (locale: Locale) => {
  return showLoginAsDefaultCountries.includes(locale);
};
